import { observer } from 'mobx-react'
import { useContext, useEffect } from 'react'
import { Header, LoadingSpinner } from '@/components/Generic'
import { Illustration } from '@/components/Illustration/Illustration'
import { StoreContext } from '@store/Root.store'
import { forceRedirect, withCommonQueryParams } from '@/methods/forceRedirect'
import { getUrlParam } from '@/methods/urlParams'

export const AgeVerificationCompletePage = observer(() => {
  const store = useContext(StoreContext)
  const {
    ageVerificationPage: { complete: trans },
  } = store.TranslationsState.translations

  // Set by the BE redirect when the transaction did not complete successfully.
  // errorReason values: User.AgeRequirementNotMet | User.Cancel | Other
  const isError = getUrlParam('error')
  const errorReason = getUrlParam('errorReason')

  useEffect(() => {
    store.InterfaceState.setSendBeforeunloadEvent(false)

    if (!isError) return

    if (errorReason === 'User.AgeRequirementNotMet') {
      forceRedirect(withCommonQueryParams('/error-age-verification-failed'))
    } else if (errorReason === 'User.Cancel') {
      forceRedirect(withCommonQueryParams('/error-transaction-cancelled'))
    } else {
      forceRedirect(withCommonQueryParams('/error'))
    }
  }, [])

  if (isError) {
    return (
      <div className="page-container mobile-m-0 vertically-centered">
        <LoadingSpinner />
      </div>
    )
  }

  return (
    <div className="page-container mobile-m-0 vertically-centered">
      <Illustration type="success" />

      <Header className="m-0-0-30">{trans.successHeader}</Header>

      <p className="generic__paragraph-centered m-0-0-30">{trans.successDescription}</p>
    </div>
  )
})
